import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@material-ui/core';
import React, { useState } from 'react';
import { Ordem } from './OrderIndex';
import MaterialTable from '@material-table/core';
import { Check, CloudDownload } from '@material-ui/icons';
import axios_instance from '../../../services/auth/jwt/config';
import sweetAlert from '../../../f5/utils/sweetAlert';

interface DialogNovaPerguntaProps {
    open: boolean;
    onClose: (reload?: boolean) => void;
    ordem: Ordem | null;
}

export default function DialogNovaPergunta({ open, onClose, ordem, ...props }: DialogNovaPerguntaProps) {
    const [pergunta, setPergunta] = useState<string>('');
    const [loading, setLoading] = useState(false)

    const onDownload = (row: any) => {
        fetch(`https://ribasdigital.cidadeinteligente.app.br/api/ordem_servico/pergunta/download/${row.id}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        }).then(res => res.blob()).then(blob => {
            if (blob.type === 'application/json') {
            } else {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = row.imagem.split('/').pop() ?? 'download';
                a.click();
                window.URL.revokeObjectURL(url);
                a.remove();
            }
        }).catch(err => {
        }).finally(() => {
        })
    }

    const onSubmit = () => {
        setLoading(true)
        axios_instance.post<{ success: boolean }>(`/ordem_servico/pergunta/perguntar/${ordem?.id}`, {
            pergunta
        }).then((r) => {
            if (r.data.success) {
                sweetAlert('success', "Pergunta Enviada com Sucesso")
                onClose(true)
            } else {
                sweetAlert("error", 'Erro ao enviar a pergunta!')
            }
        }).catch(() => {
            sweetAlert('error', 'Erro ao enviar a pergunta')
        }).finally(() => {
            setLoading(false)
        })
    }

    const onRead = (row: any) => {
        setLoading(true)
        axios_instance.post<{ success: boolean }>(`/ordem_servico/pergunta/marcar_como_lida/${row.id}`)
            .then((r) => {
                if (r.data.success) {
                    sweetAlert('success', "Pergunta marcada como lida com sucesso")
                } else {
                    sweetAlert("error", 'Erro ao marcar a pergunta como lida!')
                }
            }).catch(() => {
                sweetAlert('error', 'Erro ao marcar a pergunta como lida')
            }).finally(() => {
                setLoading(false)
            })
    }

    return <Dialog open={open} onClose={() => onClose()} maxWidth="lg" fullWidth>
        <DialogContent>
            <MaterialTable
                title="Perguntas Realizadas"
                data={ordem?.perguntas ?? []}
                columns={[
                    { title: 'Pergunta', field: 'pergunta' },
                    { title: 'Enviado em', field: 'created_at', type: 'datetime' },
                    { title: 'Resposta', field: 'resposta' },
                    { title: 'Respondido em', field: 'updated_at', type: 'datetime' },
                ]}
                actions={[
                    ((row) => ({
                        tooltip: 'Baixar Imagem', icon: () => <CloudDownload />, onClick: () => {
                            onDownload(row)
                        }, disabled: !row.imagem
                    })),
                    ((row) => ({
                        tooltip: 'Marcar como Lida', icon: () => <Check />, onClick: (_, rowData) => {
                            onRead(rowData)
                        }, disabled: row.visualizada
                    }))
                ]}
                options={{
                    actionsColumnIndex: -1,
                }}
            />
            <TextField
                label="Nova Pergunta"
                value={pergunta}
                onChange={(e) => setPergunta(e.target.value)}
                fullWidth
                multiline
                minRows={3}
            />
        </DialogContent>
        <DialogActions>
            <Box display="flex" justifyContent="space-between" width="100%">
                <Button onClick={() => onClose()} color="secondary" variant="outlined">
                    Cancelar
                </Button>
                <Button onClick={onSubmit} color="primary" disabled={!pergunta} variant="contained">
                    Enviar Pergunta
                </Button>
            </Box>
        </DialogActions>
    </Dialog>
}